import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategorySection() {
  return (
    <section className="bg-background-100 py-10 md:py-14">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="text-xl md:text-2xl font-heading text-foreground-950">
            漫画分类
          </h2>
          <p className="text-sm text-foreground-500 mt-1">按类型找到你喜欢的漫画</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
          {categories.filter((c) => c.slug !== 'all').map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-xl p-5 text-center transition-all duration-300 hover:scale-[1.03] cursor-pointer"
            >
              <div className="w-14 h-14 mx-auto mb-3 rounded-2xl bg-accent-100 flex items-center justify-center group-hover:bg-accent-200 transition-colors">
                <i className={`${cat.icon} text-2xl text-accent-600`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 mt-1">海量{cat.name}资源</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}